import React from 'react';
import Logo from './Logo';
import UserProfile from './UserProfile';
import Navigation from './Navigation';

const Sidebar = () => (
    <div className="gx-sidebar-content">
        <Logo />
        <UserProfile />
        <Navigation />
    </div>
);

export default Sidebar;
